module.exports = __webpack_public_path__ + "static/img/图片4.12acee5e.png";